import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/consumption/title.png'
import _imports_1 from '../../assets/img/consumption/arc_bg.png'
import _imports_2 from '../../assets/img/consumption/cart.png'
import _imports_3 from '../../assets/img/consumption/ring_car_bg.png'


const _hoisted_1 = { class: "consumption-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("h2", null, "Consumption"),
  /*#__PURE__*/_createVNode("div", { class: "img" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_3 = { class: "consumption-list" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"item zh-item\" style=\"padding-bottom:15.7407vw;\"><div class=\"zh-bg\"></div><div class=\"content\"><h3><span>今世簪花</span><span>世世漂亮</span></h3><p class=\"big\" style=\"line-height:1.33;\">簪过了，</p><p class=\"big\" style=\"line-height:1.33;margin-bottom:2.1296vw;\">根本舍不得拆</p><p style=\"margin-bottom:4.6296vw;\">把浪漫戴在头上</p><p>2024年，</p><p>簪花的风吹到了成都，</p><p>洛带古镇</p><p>仿佛成了簪花的</p><p class=\"point\" style=\"margin:0 0 7.037vw -5.5556vw;\">“宇宙中心”</p><p class=\"big\">簪花+汉服，</p><p class=\"big\" style=\"margin-bottom:5vw;\">5步一公主</p><p>簪花成新宠，国潮电动车“潮”出圈，</p><p style=\"margin-bottom:3.1481vw;\">马面裙热度依旧……</p><p>当前</p><p class=\"point\">国货潮品</p><p>占据消费市场</p><p style=\"font-size:7.8704vw;display:flex;margin-left:-3vw;align-items:center;\"><span style=\"color:#a35c8f;font-size:52.8704vw;line-height:1;font-family:&#39;TENSANS-BOLD&#39;;\">C</span>位</p></div></div>", 1)
const _hoisted_5 = {
  class: "item",
  style: {"padding-bottom":"19.4444vw"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "label" }, "2023年", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"1.8519vw"} }, "中国国潮经济市场规模为", -1)
const _hoisted_8 = { class: "arc-bg-container" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "arc-bg" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"6.5741vw"} }, [
  /*#__PURE__*/_createVNode("span", {
    class: "count-up",
    style: {"font-size":"20vw","color":"#aa6c9a","font-family":"'jdzh'","letter-spacing":"-0.463vw"}
  }, "20517.4"),
  /*#__PURE__*/_createTextVNode("亿元")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"6.2963vw"} }, "同比增长", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { style: {"color":"#aa6c9a","font-size":"14.8148vw","font-family":"'jdzh'","line-height":"1.1"} }, [
  /*#__PURE__*/_createVNode("span", { class: "count-up" }, "9.44"),
  /*#__PURE__*/_createTextVNode("%")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"7.5vw"} }, "持续上新的国货潮品", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"7.5vw"} }, "成为我国消费增长的新引擎之一", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"7.5vw"} }, "更折射出新一代消费者的", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"7.4074vw","line-height":"1.2","font-weight":"bold"} }, "文化自信和民族认同感", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "cart" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", {
  class: "label",
  style: {"margin-bottom":"5.0926vw"}
}, "2024年上半年", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, "全国社会消费品", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"6.0185vw"} }, "零售总额", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", {
  class: "count-up",
  style: {"font-size":"20vw","letter-spacing":"-0.463vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1"}
}, "235969", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { style: {"margin":"-2.3148vw 0 3.2407vw"} }, "亿 元", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, "同比增长", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14.8148vw","letter-spacing":"-0.3704vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1.1","margin-bottom":"5.5556vw"} }, [
  /*#__PURE__*/_createVNode("span", { class: "count-up" }, "3.7"),
  /*#__PURE__*/_createTextVNode("%")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, "其中", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("p", null, "限额以上单位商品", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"2.3148vw"} }, "零售额", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("p", {
  class: "count-up",
  style: {"font-size":"14.8148vw","letter-spacing":"-0.3704vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1"}
}, "83865", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { style: {"margin":"-1.3889vw 0 3.7037vw"} }, "亿 元", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"8.0556vw","font-weight":"bold"} }, "汽车类消费", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"8.0556vw","font-weight":"bold","margin-bottom":"23.1481vw"} }, "排名第一", -1)
const _hoisted_32 = {
  class: "car-wrapper",
  style: {"margin-bottom":"18.5185vw"}
}
const _hoisted_33 = /*#__PURE__*/_createVNode("p", {
  class: "label",
  style: {"margin-bottom":"6.9444vw"}
}, "2024年上半年", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"1.8519vw"} }, "我国新能源汽车产量", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("p", {
  class: "count-up",
  style: {"font-size":"20vw","letter-spacing":"-0.463vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1"}
}, "492.9", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { style: {"margin":"-2.3148vw 0 6.0185vw"} }, "亿 元", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", null, "同比增长", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14.8148vw","letter-spacing":"-0.3704vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1"} }, [
  /*#__PURE__*/_createVNode("span", { class: "count-up" }, "30.1"),
  /*#__PURE__*/_createTextVNode("%")
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { style: {"margin-bottom":"1.8519vw"} }, "我国新能源汽车销量", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("p", {
  class: "count-up",
  style: {"font-size":"20vw","letter-spacing":"-0.463vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1"}
}, "494.4", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { style: {"margin":"-2.3148vw 0 6.0185vw"} }, "亿 元", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("p", null, "同比增长", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"14.8148vw","letter-spacing":"-0.3704vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":"1"} }, [
  /*#__PURE__*/_createVNode("span", { class: "count-up" }, "32"),
  /*#__PURE__*/_createTextVNode("%")
], -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("p", {
  class: "label",
  style: {"margin-bottom":"5.0926vw"}
}, "2024年7月 ", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"9.2593vw"} }, "国内新能源乘用车市场", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"8.3333vw","line-height":"9.2593vw"} }, "迎来里程碑式时刻", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"9.2593vw"} }, "新能源汽车渗透率月度首次", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("p", { style: {"line-height":"9.2593vw"} }, "突破50%", -1)
const _hoisted_49 = { class: "ring-wrapper" }
const _hoisted_50 = /*#__PURE__*/_createVNode("p", { style: {"font-size":"16.2037vw","letter-spacing":"-0.3704vw","color":"#aa6c9a","font-family":"'jdzh'","line-height":".95","margin-top":"23.1481vw"} }, [
  /*#__PURE__*/_createVNode("span", { class: "count-up" }, "51.1"),
  /*#__PURE__*/_createTextVNode("%")
], -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", null, "月度零售销量", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("p", null, "超过燃油乘用车", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "ring-bg" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_54 = /*#__PURE__*/_createStaticVNode("<div class=\"item end-item\"><p>2024年的政府工作报告明确提出：</p><p>培育壮大新型消费</p><div class=\"qipao-line\" style=\"margin:3.7037vw 0 2.3148vw;\"><p>实施 </p><div class=\"qipao\"> 数字<br>消费 </div><div class=\"qipao\"> 绿色<br>消费 </div><div class=\"qipao\"> 健康<br>消费 </div><p> 促进政策</p></div><div class=\"qipao-line\"><p>积极培育</p><div class=\"qipao\"> 智能<br>家居 </div><div class=\"qipao\"> 文娱<br>旅游 </div><div class=\"qipao\"> 体育<br>赛事 </div><div class=\"qipao\"> 国货<br>潮品 </div><p>等</p></div><p>新的消费增长点</p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dots = _resolveComponent("Dots")
  const _component_Road = _resolveComponent("Road")
  const _component_Car = _resolveComponent("Car")
  const _component_Ring = _resolveComponent("Ring")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Dots)
        ]),
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16
      ]),
      _createVNode("div", {
        class: ["item shopping-item", [_ctx.isShoppingShow && 'show']]
      }, [
        _createVNode(_component_Road),
        _hoisted_17,
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _hoisted_21,
        _hoisted_22,
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _hoisted_26,
        _hoisted_27,
        _hoisted_28,
        _hoisted_29,
        _hoisted_30,
        _hoisted_31,
        _createVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode("div", {
            class: ["car-inner", [_ctx.carShowIndex === 0 && 'active']]
          }, [
            _hoisted_34,
            _hoisted_35,
            _hoisted_36,
            _createVNode(_component_Car, {
              carShowIndex: _ctx.carShowIndex,
              data: _ctx.carDataList[0]
            }, null, 8, ["carShowIndex", "data"]),
            _hoisted_37,
            _hoisted_38
          ], 2),
          _createVNode("div", {
            class: ["car-inner car-sale-inner", [_ctx.carShowIndex === 1 && 'active']]
          }, [
            _hoisted_39,
            _hoisted_40,
            _hoisted_41,
            _createVNode(_component_Car, {
              carShowIndex: _ctx.carShowIndex,
              data: _ctx.carDataList[1]
            }, null, 8, ["carShowIndex", "data"]),
            _hoisted_42,
            _hoisted_43
          ], 2)
        ]),
        _hoisted_44,
        _hoisted_45,
        _hoisted_46,
        _hoisted_47,
        _hoisted_48,
        _createVNode("div", _hoisted_49, [
          _createVNode(_component_Ring, { ringShow: _ctx.ringShow }, null, 8, ["ringShow"]),
          _hoisted_50,
          _hoisted_51,
          _hoisted_52,
          _hoisted_53
        ])
      ], 2),
      _hoisted_54
    ])
  ]))
}